// // src/redux/examsubjectfieldSlice.js

// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import {
//   get_examsubjectfield,
//   add_examsubjectfield,
//   update_examsubjectfield,
//   delete_examsubjectfield,
// } from '../Service/ApiServices.js';
// import { toast } from 'react-toastify';

// const initialState = {
//   examsubjectfield: [],
//   examsubjectfieldlist:[],
//   school_id:"",
//   totalPages: 0,
//   pageSize: 10,
//   count: 0,
//   activePage: 1,
//   loading: false,
//   error: null,
//   addLoading: false,
//   IsEditing: false,
//   formData: {
//     examtype: "",
//   },
// };

// export const fetchexamsubjectfieldlist = createAsyncThunk(
//   "examsubjectfield/fetchexamsubjectfieldlist",
//   async ({ type_id, page, page_size,school_id, token, signal }, { rejectWithValue }) => {

//     try {
//       const response = await get_examsubjectfield(page, page_size,school_id,type_id,token, signal);

        
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response.message);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );


// // Async Thunks for API Calls
// export const fetchexamsubjectfield = createAsyncThunk(
//   "examsubjectfield/fetchexamsubjectfield",
//   async ({ type_id, page, page_size,school_id, token, signal }, { rejectWithValue }) => {

//     try {
//       const response = await get_examsubjectfield(page, page_size,school_id,type_id,token, signal);

        
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response.message);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );



// export const createexamsubjectfield = createAsyncThunk(
//   "examsubjectfield/createexamsubjectfield",
//   async ({ data,school_id, token, signal }, { rejectWithValue }) => {
//     try {
//       const response = await add_examsubjectfield(data,school_id, token, signal);
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
// export const updateexamsubjectfield = createAsyncThunk(
//   "examsubjectfield/updateexamsubjectfield",
//   async ({ data,school_id, token, signal }, { rejectWithValue }) => {
//     try {
//       const response = await update_examsubjectfield(data,school_id, token, signal);
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const deleteexamsubjectfield = createAsyncThunk(
//   "examsubjectfield/deleteexamsubjectfield",
//   async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
//     try {
//       const response = await delete_examsubjectfield({ ids },school_id, token, signal);
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response.message);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
// // examsubjectfield Slice
// const examsubjectfieldSlice = createSlice({
//   name: 'examsubjectfields',
//   initialState,
//   reducers: {
//     setActivePage(state, action) {
//       state.activePage = action.payload;
//     },
//     updateFormData(state, action) {
//       const { name, value } = action.payload;
//       state.formData[name] = value;
//     },
//     EditFormData(reduxState, action) {
//       reduxState.formData = { ...action.payload };
//     },
//     resetFormData(state) {
//       state.formData = {
//             examtype: "",

//       };
//     },
//     setexamsubjectfield(state, action) {
//       state.examsubjectfield = action.payload;
//     },
//     setIsEditing(state, action) {
//       state.IsEditing = action.payload;
//     },
//     setPageSize(state, action) {
//       state.pageSize = action.payload;
//     },
//     setSchoolId(state, action) {
//       state.school_id = action.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder  
//      .addCase(fetchexamsubjectfieldlist.fulfilled, (state, action) => {
//         state.loading = false;
//         state.examsubjectfieldlist = action.payload.results[0];
//       })
//       .addCase(fetchexamsubjectfieldlist.rejected, (state, action) => {
//         state.loading = false;
//         state.examsubjectfieldlist = [];
//       })   
//        // Fetch examsubjectfield
//        .addCase(fetchexamsubjectfield.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchexamsubjectfield.fulfilled, (state, action) => {
//         state.loading = false;
//         state.examsubjectfield = action.payload.results;
//         state.count = action.payload.count;
//         state.totalPages = Math.ceil(action.payload.count / state.pageSize);
//       })
//       .addCase(fetchexamsubjectfield.rejected, (state, action) => {
//         state.loading = false;
//         state.examsubjectfield = [];
//         state.error = action.payload;
//       })

//       // Add examsubjectfield
//       .addCase(createexamsubjectfield.pending, (state) => {
//         state.addLoading = true;
//       })
//       .addCase(createexamsubjectfield.fulfilled, (state, action) => {
//         state.addLoading = false;
//         state.IsEditing = false;
//         toast.success(action.payload.message || "Something went wrong!");
//       })
//       .addCase(createexamsubjectfield.rejected, (state, action) => {
//         state.addLoading = false;
//         state.error = action?.payload?.data?.message;
//         const errorMessage = action?.payload?.data?.message || "Something went wrong!";
//         toast.info(errorMessage);  
//         state.IsEditing = false;
//       })
//       // Update examsubjectfield
//       .addCase(updateexamsubjectfield.pending, (state) => {
//         state.addLoading = true;
//       })
//       .addCase(updateexamsubjectfield.fulfilled, (state, action) => {
//         state.addLoading = false;
//         state.IsEditing = false;
//         toast.success(action?.payload?.message || "Something went wrong!");
//       })
//       .addCase(updateexamsubjectfield.rejected, (state, action) => {
//         state.addLoading = false;
//         state.error = action?.payload?.data?.message;
//         state.IsEditing = false;
//         const errorMessage = action?.payload?.data?.message || "Something went wrong!";
//         toast.info(errorMessage); 
//       })
//       // Delete examsubjectfield
//       .addCase(deleteexamsubjectfield.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(deleteexamsubjectfield.fulfilled, (state, action) => {
//         state.loading = false;
//         console.log(action.payload);
//         toast.success(action?.payload?.message || "Something went wrong!");
//       })
//       .addCase(deleteexamsubjectfield.rejected, (state, action) => {
//         state.loading = false;
//         toast.info(action?.payload?.message || "Something went wrong!");
//         state.error = action.payload;
//       });
//   },
// });

// // Export the actions and the reducer
// export const {   setexamsubjectfield,
//   setActivePage,
//   updateFormData,
//   EditFormData,
//   resetFormData,
//   setIsEditing,
//   setSchoolId,
//   setPageSize } = examsubjectfieldSlice.actions;
// export default examsubjectfieldSlice.reducer;
// src/redux/examsubjectfieldSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_examsubjectfield,
  add_examsubjectfield,
  update_examsubjectfield,
  delete_examsubjectfield,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  examsubjectfield: [],
  examsubjectfieldlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
  },
};

export const fetchexamsubjectfieldlist = createAsyncThunk(
  "examsubjectfield/fetchexamsubjectfieldlist",
  async ({school_id, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_examsubjectfield(1, 20,school_id,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// Async Thunks for API Calls
export const fetchexamsubjectfield = createAsyncThunk(
  "examsubjectfield/fetchexamsubjectfield",
  async ({page, page_size,school_id, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_examsubjectfield(page, page_size,school_id,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createexamsubjectfield = createAsyncThunk(
  "examsubjectfield/createexamsubjectfield",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_examsubjectfield(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexamsubjectfield = createAsyncThunk(
  "examsubjectfield/updateexamsubjectfield",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_examsubjectfield(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexamsubjectfield = createAsyncThunk(
  "examsubjectfield/deleteexamsubjectfield",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_examsubjectfield({ ids },school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// examsubjectfield Slice
const examsubjectfieldSlice = createSlice({
  name: 'examsubjectfields',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
             name: "",

      };
    },
    setexamsubjectfield(state, action) {
      state.examsubjectfield = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder  
     .addCase(fetchexamsubjectfieldlist.fulfilled, (state, action) => {
        state.loading = false;
        state.examsubjectfieldlist = action.payload.results;
      })
      .addCase(fetchexamsubjectfieldlist.rejected, (state, action) => {
        state.loading = false;
        state.examsubjectfieldlist = [];
      })   
       // Fetch examsubjectfield
       .addCase(fetchexamsubjectfield.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexamsubjectfield.fulfilled, (state, action) => {
        state.loading = false;
        state.examsubjectfield = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchexamsubjectfield.rejected, (state, action) => {
        state.loading = false;
        state.examsubjectfield = [];
        state.error = action.payload;
      })

      // Add examsubjectfield
      .addCase(createexamsubjectfield.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexamsubjectfield.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexamsubjectfield.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update examsubjectfield
      .addCase(updateexamsubjectfield.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexamsubjectfield.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexamsubjectfield.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete examsubjectfield
      .addCase(deleteexamsubjectfield.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexamsubjectfield.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexamsubjectfield.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setexamsubjectfield,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = examsubjectfieldSlice.actions;
export default examsubjectfieldSlice.reducer;
